export const ADD_CLIENT="ADD_CLIENT";
export const CLIENT_DETAILS="CLIENT_DETAILS";
export const CLIENT_DATA="CLIENT_DATA";
export const ADD_NOTICE="ADD_NOTICE";
export const NOTICE_DETAILS="NOTICE_DETAILS";
export const NOTICE_DATA="NOTICE_DATA";